<template>
 <div class="csoportdiagramok">
     <v-app id="csoportdiagramok">
       <v-btn color="success" v-if="diagrammentesgomb" v-on:click="diagrammentese">Diagram mentése<v-icon>fa-save</v-icon></v-btn>
        <v-dialog
          v-model="dialogus"
          persistent
          max-width="600px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Diagram létrehozása
              <v-icon>fa-plus</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Diagram</span>
            </v-card-title>
            <v-card-text>
              <v-select :items="diagramtipusok" prepend-inner-icon="fa-chart-bar" v-model="diagrambeallitasok.tipus" label="Diagram típusa" item-text="tipusnev" item-value="tipusszam"></v-select>
              <v-select v-if="diagrambeallitasok.tipus<=2" label="Témakör" v-model="diagrambeallitasok.kategoria"  :items="csoport.temakorok" item-text="nev" item-value="id"></v-select>
              <v-select v-if="diagrambeallitasok.tipus==3" label="Gyakorlat" v-model="diagrambeallitasok.gyakorlat" prepend-inner-icon="fa-dumbbell" :items="csoport.gyakorlatok" item-text="nev" item-value="id"></v-select>
              <v-select v-if="diagrambeallitasok.tipus==3" label="Nem" v-model="diagrambeallitasok.nem" prepend-inner-icon="fa-venus-mars" :items="nemek" item-text="nem" item-value="nemszam"></v-select>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialogus = false"
              >
                Bezárás
                <v-icon>fa-times</v-icon>
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="diagramletrehozasa()"
                v-if="(diagrambeallitasok.tipus<=2 && diagrambeallitasok.kategoria) || (diagrambeallitasok.tipus==3 && diagrambeallitasok.gyakorlat &&diagrambeallitasok.nem)"
              >
                Létrehozás
                <v-icon>fa-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
       <canvas id="diagram"></canvas>
     </v-app>
 </div>

</template>

<script>
/*import axios from 'axios'
axios.defaults.withCredentials = true*/


    import router from "../router"
const diagram1=document.getElementById("diagram1");
var diagram;
export default {
 props: ['id'],
 components: {
 },
 data: function () {
   return {
     diagrammentesgomb: false,
     csoport: {},
     dialogus: false,
     diagrambeallitasok: {tipus: 0, kategoria: "m", gyakorlat: undefined, nem: undefined},
     diagramtipusok: [
       {tipusnev: "Témakörönkénti gyakorlatátlag", tipusszam: 0},
       {tipusnev: "Témakörönkénti jegyek tanulónként, gyakorlatonként", tipusszam: 1},
       {tipusnev: "Témakörönkénti tanulói jegyátlag", tipusszam: 2},
       {tipusnev: "Tanulók elért eredményei gyakorlatonként, nemenként", tipusszam: 3}
     ],
     nemek: [{nem: "Lány", nemszam: "1"}, {nem: "Fiú", nemszam: "0"}]

   }
 },
 computed: {
 ujtanulolany: {
   get: function(){
     return !this.ujtanulofiu;
   },
   set: function(ujertek){
     this.ujtanulofiu=!ujertek
   },
 },
 megjelenitettgyakorlatok: function(){
   var szamlalo=0;
   for(const gyakorlat of this.csoport.gyakorlatok){
     if(gyakorlat.temakor==this.megjelenitendotemakor){
       szamlalo++;
     }
   }
   return szamlalo;
 }
 },
 methods: {
   kijelentkezes: function() {
           this.$store.commit('bejelentkezve', false)
           router.push('/bejelentkezes');
           this.$store.commit('admin',false)
   },
   szingeneralas: function() {
     var r, g, b;
     do{
       r = Math.floor(Math.random() * 255);
       g = Math.floor(Math.random() * 255);
       b = Math.floor(Math.random() * 255);
     } while(Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))<155&&Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))>100)
    return "rgb(" + r + "," + g + "," + b + ")";
   },
   diagrammentese: function() {
     if(diagram) require("downloadjs")(diagram.toBase64Image(), "diagram.png", "image/png");
   },
   diagramletrehozasa: function() {
     var diagramadatok = {}
     switch(this.diagrambeallitasok.tipus){
       case 0: //Kategóriánkénti gyakorlatátlag
       var gyakorlatokjegyei = [];
       var szinek = [];
       this.csoport.gyakorlatok.forEach(gy => {
         if(this.diagrambeallitasok.kategoria=="m" || this.diagrambeallitasok.kategoria==gy.temakor){
           gyakorlatokjegyei.push(this.gyakorlatatlagkalkulalas(gy.id));
           szinek.push(this.szingeneralas());
         }
       })
       diagramadatok = {
         type: 'bar',
         data: {
             labels: this.csoport.gyakorlatok.filter(gy => this.diagrambeallitasok.kategoria=="m" ? true : this.diagrambeallitasok.kategoria==gy.temakor).map(a => a.nev),
             datasets: [{
                 label: 'Átlag',
                 data: gyakorlatokjegyei,
                 borderWidth: 1,
                 backgroundColor: szinek,
                 borderColor: szinek
             }],
         },
         options: {
             scales: {
                 yAxes: [{
                     ticks: {
                         beginAtZero: false,
                         min: 0,
                         max: 5
                     }
                 }]
             },
             legend: {
               display:false
             },
             title: {
               display: true,
               text: (this.diagrambeallitasok.kategoria=="m" ? "Minden" : this.csoport.temakorok.find(k => k.id==this.diagrambeallitasok.kategoria).nev) + " témakör gyakorlatainak átlaga",
               fontSize: 20,
               fontColor: 'blue'
             }
           }
       }
       break;
       case 1: //Témakörönkénti jegyek tanulónként, gyakorlatonként
       var gyakorlatok = () => {
         var gyakok = [];
         this.csoport.gyakorlatok.filter(gy => this.diagrambeallitasok.kategoria=="m" ? true : this.diagrambeallitasok.kategoria==gy.temakor).forEach(gy => {
           var gyak = {label: gy.nev, data: [], borderWidth: 1, backgroundColor: this.szingeneralas()};
           this.csoport.tanulok.forEach(t => {
             gyak.data.push(this.jegykalkulalas(t.id,gy.id,t.nem==0)[2])
           })
           gyakok.push(gyak)
         })
         return gyakok;
       }
       diagramadatok = {
         type: 'bar',
         data: {
             labels: this.csoport.tanulok.map(t => t.nev),
             datasets: gyakorlatok(),
         },
         options: {
             scales: {
                 yAxes: [{
                     ticks: {
                         beginAtZero: false,
                         min: 0,
                         max: 5,
                         stepSize: 1
                     }
                 }]
             },
             title: {
               display: true,
               text: (this.diagrambeallitasok.kategoria=="m" ? "Minden" : this.csoport.temakorok.find(k => k.id==this.diagrambeallitasok.kategoria).nev) + " témakör jegyei tanulónként, gyakorlatonként",
               fontSize: 20,
               fontColor: 'blue'
             }
           }
         }
       break;
       case 2: //Témakörönkénti tanulói jegyátlag
         var szinek = []; var csoportatlag = []; var csa = this.kategoriaatlagkalkulalas(this.diagrambeallitasok.kategoria)
         for(var i=0;i<this.csoport.tanulok.length;i++) {szinek.push(this.szingeneralas()); csoportatlag.push(csa)}
         diagramadatok = {
           type: 'bar',
           data: {
               labels: this.csoport.tanulok.map(t => t.nev),
               datasets: [
                 {
                  label: 'Csoportátlag',
                  data: csoportatlag,
                  borderColor: this.szingeneralas(),
                  backgroundColor: 'rgba(173,255,47,0.4)',
                  // Changes this dataset to become a line
                  type: 'line'},
                 {
                   label: 'Átlag',
                   data: this.csoport.tanulok.map(t => this.tanulokategoriaatlagkalkulalas(t.id,t.nem==0,this.diagrambeallitasok.kategoria)),
                   borderWidth: 1,
                   backgroundColor: szinek,
                   borderColor: szinek
               },

              ],
           },
           options: {
               scales: {
                   yAxes: [{
                       ticks: {
                           beginAtZero: false,
                           min: 0,
                           max: 5,
                       }
                   }]
               },
               legend: {
                 display:false
               },
               title: {
                 display: true,
                 text: (this.diagrambeallitasok.kategoria=="m" ? "Minden" : this.csoport.temakorok.find(k => k.id==this.diagrambeallitasok.kategoria).nev) + " témakör jegyeinek átlaga tanulónként",
                 fontSize: 20,
                 fontColor: 'blue'
               }
             }
           }

       break;
       case 3: //Tanulók elért eredményei gyakorlatonként, nemenként
        var szinek = this.csoport.tanulok.filter(t => t.nem==this.diagrambeallitasok.nem).map(t => this.szingeneralas());
        diagramadatok = {
          type: 'bar',
          data: {
              labels: this.csoport.tanulok.filter(t=> t.nem==this.diagrambeallitasok.nem).map(t => t.nev),
              datasets: [
                {
                  label: 'Elért eredmény',
                  data: this.csoport.tanulok.filter(t=> t.nem==this.diagrambeallitasok.nem).map(t => this.csoport.elvegzettgyakorlatok[this.elvegzettmennyisegindexletrehozas(t.id,this.diagrambeallitasok.gyakorlat)].elvegzettmennyiseg),
                  borderWidth: 1,
                  backgroundColor: szinek,
                  borderColor: szinek
                },

             ],
          },
          options: {
              scales: {
                  yAxes: [{
                      ticks: {
                          beginAtZero: false,
                      }
                  }]
              },
              legend: {
                display:false
              },
              title: {
                display: true,
                text: "A " + (this.diagrambeallitasok.nem==0 ? "fiúk" : "lányok") + " elért eredményei " + this.csoport.gyakorlatok.find(gy => gy.id==this.diagrambeallitasok.gyakorlat).nev + " gyakorlatban",
                fontSize: 20,
                fontColor: 'blue'
              }
            }
          }
       break;
     }
     this.dialogus=false;
     if (diagram) diagram.destroy();
     diagram=new this.Chart(document.getElementById("diagram"), diagramadatok);
     this.diagrammentesgomb = true
   },
   kategoriaatlagkalkulalas: function(kategoria) {
     var atlagosszeg=0;
     var jegyekszama=0;
       this.csoport.elvegzettgyakorlatok.forEach(elvegzettgyakorlat => {
         if(elvegzettgyakorlat.elvegzettmennyiseg>0 && (kategoria=="m" || this.csoport.gyakorlatok.find(gy => gy.id==elvegzettgyakorlat.gyakorlatid).temakor==kategoria)){
           jegyekszama++;
           atlagosszeg+=this.jegykalkulalas(elvegzettgyakorlat.tanuloid,elvegzettgyakorlat.gyakorlatid,this.csoport.tanulok.find(t => t.id==elvegzettgyakorlat.tanuloid).nem==0)[2];
         }
       })
       return Math.round((atlagosszeg/jegyekszama) * 100) / 100

   },
   gyakorlatatlagkalkulalas: function(gyakorlatid) {
    var atlagosszeg = 0;
    var jegyekszama = 0;
    this.csoport.elvegzettgyakorlatok.filter(elvegzettgyakorlat => elvegzettgyakorlat.gyakorlatid==gyakorlatid).forEach((e) => {
      if(e.elvegzettmennyiseg>0){
        jegyekszama++;
        atlagosszeg+=this.jegykalkulalas(e.tanuloid,e.gyakorlatid,this.csoport.tanulok.find(t => t.id==e.tanuloid).nem==0)[2];
      }
    })
    return Math.round((atlagosszeg/jegyekszama) * 100) / 100
   },
   tanulokategoriaatlagkalkulalas: function(tanuloid, nem,  kategoria) {
     var atlagosszeg = 0;
     var gyakorlatokszama =0;
     this.csoport.gyakorlatok.forEach((e) => {
       if(kategoria=="m" || e.temakor==kategoria){
         gyakorlatokszama++;
         var jegy = this.jegykalkulalas(tanuloid,e.id,nem)[2]
         atlagosszeg+= jegy;
         if(!jegy){
           gyakorlatokszama--;
         }
       }
     })
     if(!isNaN(atlagosszeg/gyakorlatokszama)){
       return Math.round((atlagosszeg/gyakorlatokszama) * 100) / 100/*atlagosszeg/gyakorlatokszama*/;
     }
     else{
       return "";
     }
   },
   jegykalkulalas: function (tanuloid, gyakorlatid, fiu) {
     var gyakorlat = this.csoport.gyakorlatok.find(({ id }) => id === gyakorlatid)
     var elvegzettmennyiseg = this.csoport.elvegzettgyakorlatok[this.elvegzettmennyisegindexletrehozas(tanuloid,gyakorlatid)].elvegzettmennyiseg;
     if(fiu){
       if(gyakorlat.novekvo==1){
         if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny5){
           return [5, elvegzettmennyiseg, 5];
         }
         else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny4){
           return [4, elvegzettmennyiseg, 4];
         }
         else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny3){
           return [3, elvegzettmennyiseg, 3];
         }
         else if(elvegzettmennyiseg>=gyakorlat.fkovetelmeny2){
           return [2, elvegzettmennyiseg, 2];
         }
         else if(elvegzettmennyiseg>0){
           return [1, elvegzettmennyiseg, 1];
         }
         else{
           return ["1 (0-t teljesített!!!!)", elvegzettmennyiseg, 0];
         }
       }
       else{
         if(elvegzettmennyiseg>gyakorlat.fkovetelmeny2){
           return [1, elvegzettmennyiseg, 1];
         }
         else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny3){
           return [2, elvegzettmennyiseg, 2];
         }
         else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny4){
           return [3, elvegzettmennyiseg, 3];
         }
         else if(elvegzettmennyiseg>gyakorlat.fkovetelmeny5){
           return [4, elvegzettmennyiseg, 4];
         }
         else if(elvegzettmennyiseg>0){
           return [5, elvegzettmennyiseg, 5];
         }
         else{
           return ["0-t teljesített.", elvegzettmennyiseg, 0];
         }
       }
     }
     else{
       if(gyakorlat.novekvo==1){
         if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny5){
           return [5, elvegzettmennyiseg,5];
         }
         else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny4){
           return [4, elvegzettmennyiseg,4];
         }
         else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny3){
           return [3, elvegzettmennyiseg,3];
         }
         else if(elvegzettmennyiseg>=gyakorlat.lkovetelmeny2){
           return [2, elvegzettmennyiseg,2];
         }
         else if(elvegzettmennyiseg>0){
           return [1, elvegzettmennyiseg,1];
         }
         else{
           return ["1 (0-t teljesített!!!!)", elvegzettmennyiseg,0];
         }
       }
       else{
         if(elvegzettmennyiseg>gyakorlat.lkovetelmeny2){
           return [1, elvegzettmennyiseg,1];
         }
         else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny3){
           return [2, elvegzettmennyiseg,2];
         }
         else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny4){
           return [3, elvegzettmennyiseg,3];
         }
         else if(elvegzettmennyiseg>gyakorlat.lkovetelmeny5){
           return [4, elvegzettmennyiseg,4];
         }
         else if(elvegzettmennyiseg>0){
           return [5, elvegzettmennyiseg,5];
         }
         else{
           return ["0-t teljesített.", elvegzettmennyiseg,0];
         }
       }

     }
   },

   elvegzettmennyisegindexletrehozas: function(tanulo,gyakorlat) {
     var index= this.elvegzettmennyisegid(tanulo,gyakorlat);
     if(index!=-1){
       return index;
     }
     else{
       this.csoport.elvegzettgyakorlatok.push({id: -1, elvegzettmennyiseg:0, gyakorlatid: gyakorlat, tanuloid: tanulo});
       /*console.log({id: -1, elvegzettmennyiseg:0, gyakorlatid: gyakorlat, tanuloid: tanulo})
       console.log(this.csoport.elvegzettgyakorlatok[this.elvegzettmennyisegid(tanulo,gyakorlat)])*/

       return this.elvegzettmennyisegid(tanulo,gyakorlat);
     }
   },
   elvegzettmennyisegszamitas: function (tanulo, gyakorlat) {
     var index = this.elvegzettmennyisegid(tanulo, gyakorlat)
     if (index != -1) {
       return this.csoport.elvegzettgyakorlatok[index].elvegzettmennyiseg
     } else {
       return '0'
     }
   },
   elvegzettmennyisegid: function (tanulo, gyakorlat) {
     var index = this.csoport.elvegzettgyakorlatok.findIndex(elvegzettgyakorlat => {
                 var tanuloOK = elvegzettgyakorlat.tanuloid == tanulo
                 var gyakorlatOK = elvegzettgyakorlat.gyakorlatid == gyakorlat
                 return tanuloOK & gyakorlatOK
               })
     return index
   },
   csoportfrissitese: function () {
     this.axios
       .get(this.$store.state.backendeleres+'csoportok/csoport/' + this.id)
       .then(response => {this.csoport = response.data;
         this.csoport.temakorok.push({id: "m", nev: "Mind"})
         if(response.data.bejelentkezve==false){
             this.kijelentkezes();
           }
           if(response.data.sablon) {
             router.push('/csoportok');
           }
         })
   },
   objektumatadas: function (objektum) {
     return JSON.parse(JSON.stringify(objektum))
   }
 },
 mounted () {
   this.csoportfrissitese();
 }
}
</script>
